export default __webpack_public_path__ + "static/broadcastImg1-17e6a7f084af0ddf8849101319ecb9d3.png";